const padTo2Digits = (num: number) => {
  return num.toString().padStart(2, '0');
};

export const formatDate = (date: Date | ''): [string, string] | undefined => {
  if (typeof date === 'string' && date === '') return;

  const yearMonthDay = [
    date.getFullYear(),
    padTo2Digits(date.getDate()),
    padTo2Digits(date.getMonth() + 1)
  ].join('/');
  const time = [
    padTo2Digits(date.getHours()),
    padTo2Digits(date.getMinutes()),
    padTo2Digits(date.getSeconds())
  ].join(':');
  return [yearMonthDay, time];
};
